import React from 'react';
import { Message } from '../ChatUpdated/ChatUpdated.styled';

interface PinnedMessageItem {
    id: string;
    sender: {
        admin: boolean;
        name: string;
    };
    message?: {
        text?: string;
    };
    recipient: {
        replyMessageId?: string;
    };
    blocked?: boolean;
}

interface ChatPinnedMessageProps {
    pinnedMessagesArray: PinnedMessageItem[];
    messagesArray: PinnedMessageItem[];
    settings: any;
}

const ChatPinnedMessage: React.FC<ChatPinnedMessageProps> = ({ pinnedMessagesArray: [pinnedMessage], messagesArray, settings }) => (
    <>
        {pinnedMessage && !pinnedMessage.blocked && (
            <Message
                primaryColor={settings?.playerStyling?.primaryColor ?? '#126cfc'}
                name={pinnedMessage.sender.name}
                content={pinnedMessage.message?.text}
                replyContent={
                    pinnedMessage.recipient.replyMessageId && messagesArray.find((x) => x.id === pinnedMessage.recipient.replyMessageId)?.message?.text
                }
                isPinned={true}
                isAdmin={pinnedMessage.sender.admin}
                id={pinnedMessage.id}
                votes={0}
                isVoted={false}
            />
        )}
    </>
);

export { ChatPinnedMessage };
